<template>
  <div
    v-if="!deleteForm"
    class="block-login-and-reg d-flex flex-column align-center"
    id="form-registration"
  >
    <!-- лоадер -->
    <preloader v-if="loading"></preloader>

    <!-- <div v-if="textWarning !== ''" class="message-block mb-4">
      <p>{{ textWarning }}</p>
    </div> -->
    <transition name="fade" mode="out-in">
      <!-- Авторизация -->
      <div class="auth w-100" v-if="type === 'login'" key="login">
        <h2 class="header_popup mb-11 h3 text-center">{{ $t('Вход') }}</h2>

        <form
          autocomplete="off"
          @submit.prevent="validateBeforeSubmit(formScope)"
          :data-vv-scope="formScope"
          class="form-login-and-reg mb-11"
        >
          <!-- Инпут email -->
          <div class="posr form--width mb-6 input-group">
            <!-- v-validate="'required|email'" -->

            <v-input
              v-model.lazy="input.email"
              classInput="inputEmail"
              type="email"
              name="email"
              data-vv-as="«Электронная почта»"
              @onFocus="input.emailBlur = false"
              @onBlur="input.emailBlur = true"
              :error="input.emailBlur && errors.has('email', formScope)"
              v-validate="'required|email'"
              v-tooltip="{
                content: `${ errors.first('email', formScope) }`,
                show: input.emailBlur && errors.has('email', formScope),
                trigger: 'manual',
              }"
            >{{ $t('Электронная почта') }}</v-input>
          </div>
          <!-- Инпут пароль для входа -->
          <div class="posr form--width mb-4 input-group">
            <v-input
              v-model="input.password"
              type="password"
              name="password"
              data-vv-as="«Пароль»"
              @onFocus="input.passwordBlur = false"
              @onBlur="input.passwordBlur = true"
              :error="input.passwordBlur && errors.has('password', formScope)"
              v-validate="'required'"
              btn_pass
              v-tooltip="{
                content: `${ errors.first('password', formScope) }`,
                show: input.passwordBlur && errors.has('password', formScope) && !errors.has('email', formScope),
                trigger: 'manual',
              }"
              @keypress.enter="$emit('submit')"
            >{{ $t('Пароль') }}</v-input>
          </div>
          <!-- Для входа -->
          <div class="form--width d-flex justify-end mb-9" v-if="type === 'login'">
            <!-- Чекбокс "Запомнить меня" для "Входа" -->
            <!-- <label for="rem" class="form-checkbox mb-2" :class="{'checked': input.remember === true }">
            <input v-model="input.remember" id="rem" name="rem" type="checkbox">
            {{ $t('Запомнить меня') }}
            </label>-->

            <!-- Ссылка на напомнить пароль -->
            <!-- @click="toggleForm('forgot')" -->
            <a
              href="/forgotpassword"
              rel="noindex, nofollow"
              class="link-main pSmall fz13 align-self-center"
            >{{ $t('Забыли пароль?') }}</a>
          </div>

          <v-btn type="submit" color="green" big class="min-w100">{{ $t('Войти') }}</v-btn>
        </form>
        <div class="wrapper_reg-btn p-9">
          <p class="text-center mb-4">{{ $t('Нет аккаунта?') }}</p>
          <v-btn
            color="green"
            outline
            class="mx-auto d-block w-100"
            onClick="location.href='/sign-up/?from=sign-in'"
          >{{ $t('Регистрация') }}</v-btn>
          <!-- https://itq-dev-1.bimteam.pro/sign-up -->
          <!-- @click="toggleForm('registration')" -->
        </div>
      </div>

      <!-- Регистрация -->
      <!-- <div class="auth w-100" v-if="type === 'registration'" key="registration"> -->
      <!-- <h2 class="header_popup mb-11 h3 text-center">{{ $t('Регистрация') }}</h2> -->

      <!-- <form -->
      <!-- autocomplete="off" -->
      <!-- @submit.prevent="validateBeforeSubmit(formScopeReg)" -->
      <!-- :data-vv-scope="formScopeReg" -->
      <!-- class="form-login-and-reg mb-11" -->
      <!-- > -->
      <!-- Инпут email -->
      <!-- <div class="posr form--width mb-9 input-group"> -->
      <!-- <v-input -->
      <!-- v-model="input.email" -->
      <!-- :error="errors.has('emailReg', formScopeReg)" -->
      <!-- classInput="inputEmail" -->
      <!-- type="email" -->
      <!-- name="emailReg" -->
      <!-- v-validate="'required|email'" -->
      <!-- >{{ $t('Электронная почта') }}</v-input> -->
      <!-- </div> -->

      <!-- Для Регистрации -->
      <!-- <div class="mb-9"> -->
      <!-- <input -->
      <!-- v-model="input.agree" -->
      <!-- id="check" -->
      <!-- type="checkbox" -->
      <!-- name="agreement" -->
      <!-- class="checkbox mr-6" -->
      <!-- :data-vv-as="$t('Соглашение')" -->
      <!-- v-validate="'required'" -->
      <!-- checked -->
      <!-- /> -->
      <!-- <label for="check" class="d-inline-block label--checkbox"> -->
      <!-- <p class="d-inline-block agreement-label"> -->
      <!-- {{$t('Я согласен с ')}} -->
      <!-- <a -->
      <!-- href="/privacy/" -->
      <!-- rel="nofollow" -->
      <!-- target="_blank" -->
      <!-- class="link-main" -->
      <!-- >{{$t('политикой конфиденциальности')}}</a> -->
      <!-- </p> -->
      <!-- </label> -->
      <!-- </div> -->

      <!-- <v-btn -->
      <!-- type="submit" -->
      <!-- color="green" -->
      <!-- big -->
      <!-- class="min-w100 w-100 px-0" -->
      <!-- >{{ $t('Зарегистрироваться') }}</v-btn> -->
      <!-- </form> -->
      <!-- <v-btn -->
      <!-- color="gray" -->
      <!-- autofocus -->
      <!-- class="br50p mx-auto back_btn" -->
      <!-- width_btn="48px" -->
      <!-- height_btn="48px" -->
      <!-- @click="toggleForm('login')" -->
      <!-- > -->
      <!-- <i class="icon-arrow-left"></i> -->
      <!-- </v-btn> -->
      <!-- </div> -->

      <!-- Восстановить пароль -->
      <!-- <div class="auth w-100" v-if="type === 'forgot'" key="forgot"> -->
      <!-- <h2 class="header_popup mb-11 h4">{{ $t('Забыли пароль?') }}</h2> -->

      <!-- <form -->
      <!-- autocomplete="off" -->
      <!-- @submit.prevent="validateBeforeSubmit(formScopeForgot)" -->
      <!-- :data-vv-scope="formScopeForgot" -->
      <!-- class="form-login-and-reg mb-11" -->
      <!-- > -->
      <!-- Инпут email -->
      <!-- <div class="posr form--width mb-6 input-group"> -->
      <!-- <v-input -->
      <!-- v-model="input.email" -->
      <!-- :error="errors.has('emailForgot', formScopeForgot)" -->
      <!-- classInput="inputEmail" -->
      <!-- type="email" -->
      <!-- name="emailForgot" -->
      <!-- v-validate="'required|email'" -->
      <!-- >{{ $t('Электронная почта') }}</v-input> -->
      <!-- </div> -->

      <!-- <p class="mb-9 forgot-text">{{ $t('На нее мы вышлем новые данные для входа.') }}</p> -->

      <!-- <v-btn -->
      <!-- type="submit" -->
      <!-- color="green" -->
      <!-- big -->
      <!-- class="min-w100 w-100 px-0" -->
      <!-- >{{ $t('Восстановить') }}</v-btn> -->
      <!-- </form> -->
      <!-- <v-btn -->
      <!-- color="gray" -->
      <!-- class="br50p mx-auto back_btn" -->
      <!-- width_btn="48px" -->
      <!-- height_btn="48px" -->
      <!-- @click="toggleForm('login')" -->
      <!-- > -->
      <!-- <i class="icon-arrow-left"></i> -->
      <!-- </v-btn> -->
      <!-- </div> -->

      <!-- Успех! -->
      <!-- <div class="auth w-100 text-center" v-if="type === 'success'" key="success">
        <h2 class="header_popup mb-4 h4 active-color">{{ $t('Успешно') }}</h2>
        <p
          class="mb-9"
          v-if="typeSuccess === 'register'"
        >{{ $t('Спасибо за регистрацию! Данные для входа уже на вашей почте.') }}</p>
        <p
          class="mb-9"
          v-if="typeSuccess === 'forgot'"
        >{{ $t('Мы отправили инструкции по восстановлению пароля на ваш емейл') }}</p>
        <p
          class="mb-9 forgot-text"
        >{{ $t('Не нашли письмо? Скорее всего оно попало в папку «Спам».') }}</p>
        <v-btn
          @click="type='login'"
          type="submit"
          color="green"
          big
          class="mb-11 min-w100 w-100 px-0"
        >{{ $t('Продолжить') }}</v-btn>
        <a href="mailto:support@bimlib.pro" class="d-flex support-block">
          <img src="/dist/assets/front_white/img/icons/t-1.svg" alt />
          <div class="active-color supp_txt-block">
            <h6 class="h6 text-left">{{ $t('Тех поддержка') }}</h6>
            <span class="supp_txt">{{ $t('Решим все проблемы') }}</span>
          </div>
        </a>
      </!-->
      -->
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deleteForm: false,
      input: {
        email: "",
        emailBlur: false,
        password: "",
        passwordBlur: false,
        remember: true,
        agree: true,
        user_type: "designer",
        success: false
      },
      formScope: "lr",
      formScopeReg: "reg",
      formScopeForgot: "forgot",
      typeSuccess: "register",
      type: "login",
      loading: true,
      // textWarning: "",
      focusedEmail: false
    };
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.getParamInUrl();
    this.delay((this.loading = false), 1500);
    this.disableForm();
  },
  methods: {
    /**
     * При закрытии вызжающей формы удаляем всё её содержимое чтобы тултипы не баговались.
     */
    disableForm() {
      const mainNode = document.getElementById("login");
      const mutationObserver = new MutationObserver(
        (mutationsList, observer) => {
          mutationsList.forEach(mutation => {
            if (mutation.target.className.includes("closed")) {
              this.deleteForm = true;
            } else this.deleteForm = false;
          });
        }
      );
      mutationObserver.observe(mainNode, { attributes: true });
    },
    getFocusEmail(val) {
      this.focusedEmail = val;
    },
    handlerHop(event) {
      console.log(event);
    },
    // foo() {
    //   this.textWarning = this.getWarning;
    // },
    toggleForm(form) {
      this.type = form;
      setTimeout(() => {
        let inp = document.querySelector(".inputEmail");
        inp.focus();
      }, 1000);
    },
    inputEmail(data) {
      this.input.email = data;
    },
    inputPassword(data) {
      this.input.password = data;
    },
    validateBeforeSubmit(scope) {
      // console.log(scope);
      this.$validator
        .validateAll(scope)
        .then(result => {
          if (result) {
            const data = new FormData();

            // if type==login ======================================================================
            if (this.type == "login") {
              data.append("email", this.input.email);
              data.append("passwd", this.input.password);
              if (this.input.remember === true) {
                data.append("rem", "Y");
              }
              axios
                .post("/sign-in", data)
                .then(response => {
                  // console.log(response);

                  if (response.data.success === true) {
                    // "success":true,"account_type":"manufacturer","user_id":"23","vip":"norm","reload":true
                    if (localStorage.getItem("dev_mode")) {
                    } else {
                      try {
                        const { account_type, user_id, vip } = response.data
                        const isMan = account_type === "manufacturer"

                        ym(40131035, "reachGoal", "PROFILE_SIGNIN");
                        ym(40131035, "userParams", {
                          UserID: user_id,
                          manufacturer: isMan,
                          designer: !isMan,
                          UserMail: this.input.email,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                      try {
                        dataLayer.push({
                          event: "EVENT2GA",
                          eventCategory: "PROFILE",
                          eventAction: "SIGNIN",
                          eventLabel: "",
                          eventValue: "",
                          account_type: response.data.account_type,
                          userId: response.data.user_id,
                          vip: response.data.vip
                        });
                      } catch (e) {
                        console.log(e);
                      }
                      try {
                        fbq("trackCustom", "PROFILE_SIGNIN");
                      } catch (e) {
                        console.log(e);
                      }
                    }
                    this.loading = true;
                    window.location.href = this.redirrectToURL;
                    this.$noty.success(
                      `<h5>Вход выполнен</h5>
                      <span>Вы будете переадресованы.</span>`,
                      {
                        killer: true,
                        timeout: this.$store.getters.getTimeoutNoty,
                        layout: "topRight",
                        progressBar: false
                      }
                    );
                  } else if (response.data.success === false) {
                    // this.textWarning = response.data.alerts[0].text;
                    this.$noty.error(
                      `
                    <h5>Ошибка</h5>
                    <span>${response.data.alerts[0].text}</span>
                  `,
                      {
                        killer: true,
                        timeout: this.$store.getters.getTimeoutNoty,
                        layout: "topRight"
                      }
                    );
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
            }
            //end if type == login

            //if type == registration ===================================================================
            if (this.type == "registration") {
              this.loading = true;
              data.append("email", this.input.email);
              data.append("type", this.input.user_type);
              data.append("agree", "on");
              axios
                .post("/sign-up", data)
                .then(response => {
                  // console.log(response);

                  if (response.data.success === true) {
                    try {
                      ym(40131035, "reachGoal", "PROFILE_SIGNUP");
                    } catch (e) {
                      console.log(e);
                    }
                    try {
                      dataLayer.push({
                        event: "EVENT2GA",
                        eventCategory: "PROFILE",
                        eventAction: "SIGNUP",
                        eventLabel: "",
                        eventValue: ""
                      });
                    } catch (e) {
                      console.log(e);
                    }

                    try {
                      fbq("trackCustom", "PROFILE_SIGNUP");
                    } catch (e) {
                      console.log(e);
                    } // let n = new Noty({
                    //   text:
                    //     "<div class='center text-center fs18 w-100'><p>На ваш почтовый ящик <b class='fw-bold active-color'>" +
                    //     this.input.email +
                    //     "</b> отправлено письмо для активации профиля</p> <p>Для завершения регистрации, пожалуйста, <b class='fw-bold'>пройдите по ссылке в письме</b> </p> <p>Обратите внимание письмо может попасть в папку <b class='fw-bold'>спам</b></p><p class='text-center (m|p)([t,y,r,l,b,x])?(-[a-z]{2})?-6 fw-bold active-color'>Нажмите на сообщение чтобы продолжить</p></div>",
                    //   layout: "center",
                    //   theme: "sunset",
                    //   container: ".regnoty"
                    // });
                    // n.show();
                    // this.loading = false;
                    this.loading = false;
                    this.type = "success";
                    this.typeSuccess = "register";
                  } else if (response.data.success === false) {
                  }
                  this.delay((this.loading = false), 1500);
                })
                .catch(function(error) {
                  console.log(error);
                  location.reload();
                });
              // .finally(() => {
              // })
            }

            // if type == forgot ===========================================================================
            if (this.type == "forgot") {
              this.loading = true;
              data.append("email", this.input.email);
              axios.post("/forgotpassword/", data).then(response => {
                // console.log(response);
                // data:
                //     alerts: Array(1)
                // 0:
                // text: "Новый пароль отправлен на почту ixter08@gmail.com !"
                // type: "success"
                // __proto__: Object
                // length: 1
                // __proto__: Array(0)
                // success: true
                // __proto__: Object
                if (response.data.success === true) {
                  this.loading = false;
                  this.type = "success";
                  this.typeSuccess = "forgot";
                } else {
                }
              });
            }
            // end if type == forgot ==================================================================
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    login: function() {
      if (this.input.email.length !== 0 && this.input.password.length !== 0) {
      } else {
        this.haserror = true;
        this.errortext = this.$t("Пожалуйста введите данные логина");
      }
    },
    getParamInUrl: function() {
      let currentUrl = window.location.pathname;
      if (currentUrl == "/") {
        this.redirrectToURL = "/models";
        this.text_login = this.$t("Вход выполнен, переходим в каталог решений");
      } else {
        this.redirrectToURL = currentUrl;
        this.text_login = this.$t("Вход выполнен");
      }
    },
    man_or_proj: function(val) {
      this.input.user_type = val;
    },
    man_or_projHas: function(val) {
      if (this.input.user_type === val) {
        return true;
      } else {
        return false;
      }
    },
    delay(value, time) {
      _.delay(function(value) {
        return value;
      }, time);
    },
    showN: function() {
      // let n = new Noty({
      //   text:
      //     "<h1><b>" +
      //     this.input.name +
      //     "</b></h1> <br> <p>" +
      //     this.$t("На ваш почтовый ящик ") +
      //     this.input.email +
      //     "<br/>" +
      //     this.$t("отправлено письмо для активации профиля") +
      //     "</p> <p>" +
      //     this.$t("Для завершения регистрации, пожалуйста,") +
      //     "<br> <b>" +
      //     this.$t("пройдите по ссылке в письме") +
      //     "</b> </p> <p>" +
      //     this.$t("Обратите внимание письмо может попасть в папку") +
      //     " <b>" +
      //     this.$t("спам") +
      //     "</b></p>",
      //   // layout: 'center',
      //   theme: "sunset",
      //   addClass: "notyficss",
      //   container: "#registration",
      //   // closeWith: ['button'],
      //   buttons: [
      //     Noty.button(
      //       this.$t("Продолжить"),
      //       "noty-btn-go btn btn-success",
      //       function() {
      //         location.reload();
      //         n.close();
      //       }
      //     )
      //   ]
      // });
      // n.show();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
@import "./src/front_white/sass/components/mixins";

.message-block {
  p {
    text-align: center;
    @include font-main(1.6rem, bold, 1.33, normal, $warning);
  }
}
// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.2s;
// }
// .fade-enter,
// .fade-leave-to {
//   opacity: 0;
// }
.mb-19 {
  margin-bottom: 1.2667rem;
}
.wrapper_reg-btn {
  border-radius: 5px;
  border: dashed 1px $text-soft-dark;
}
.min-w100 {
  min-width: 100% !important;
}
.agreement-label {
  @include font-main(0.7333rem, normal, 1.36, 0.0067rem, $text-main);
}
.forgot-text {
  @include font-main(0.8667rem, normal, 1.54, 0.02rem, $text-second);
}
.back_btn {
  min-width: unset !important;
  min-height: unset !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  // animation: slide .3s;
}
//  .fade-leave-active {
//   animation: slide .3s;
//  }
.fade-enter {
  transform: translateX(25rem);
  // animation: slide .3s;

  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  transform: translateX(0);
}
.fade-leave-to {
  transform: translateX(-25rem);
  // animation: slide .3s reverse;
  opacity: 0;
}

.support-block {
  background-color: $active-superlight;
  border-radius: 0.6667rem;
  padding: 0.7333rem 1.6rem;
  img {
    max-width: 2.1333rem;
    object-fit: contain;
    margin-right: 9px;
  }
  .supp_txt {
    @include font-main(0.7333rem, normal, 1.55, 0.0267rem, $active);
    white-space: nowrap;
  }
}

// @keyframes slide {
//   0% {
//     transform: translateX(0);
//     opacity: 1;
//   }
//   25% {
//     transform: translateX(20px);
//     opacity: 1;
//   }
//   100% {
//     transform: translateX(-25rem);
//     opacity: 0;
//   }
// }
</style>
